import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectPageConfigurationData,
  selectPageConfigurationIsInitialized,
  selectPageConfigurationIsLoading,
} from '@/store/PageConfiguration/PageConfigurationSelectors'
import { initializeContractData, updateContractConfigData, updateContractDefaultData } from './SubscriptionFormSlice'
import { mapClientSubscriptionData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Client/mapClientSubscriptionData'
import { mapAddressSubscriptionData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Address/mapAddressSubscriptionData'
import { subscriptionFormActionsV2 } from './SubscriptionFormV2Sagas'
import { selectConfig } from './SubscriptionFormSelectors'
import useTabBar from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useTabBar'
import { useLocation } from 'react-router-dom'

const useSubscriptionForm = id => {
  const dispatch = useDispatch()
  const initialData = useSelector(selectPageConfigurationData)
  const isInitialized = useSelector(selectPageConfigurationIsInitialized)
  const pageConfigurationIsLoading = useSelector(selectPageConfigurationIsLoading)
  const { contactId } = useSelector(selectConfig)
  const { pushToOpenedContracts, existingContracts } = useTabBar()
  const { hash } = useLocation()

  useEffect(() => {
    if (!isInitialized || pageConfigurationIsLoading || !initialData) return
    const contractData = {
      client: mapClientSubscriptionData(initialData.contact ?? {}),
      addresses: mapAddressSubscriptionData(initialData),
      contracts: initialData?.contact?.contracts ?? {},
      contactId: initialData.contact?.id,
    }

    dispatch(initializeContractData(contractData))
  }, [initialData])

  //Load a given contract id from url hash
  useEffect(() => {
    if (!hash || !existingContracts || Object.keys(existingContracts).length === 0) return
    const hashId = hash.replace('#', '')
    if (existingContracts[hashId]) {
      pushToOpenedContracts(existingContracts[hashId])
      return
    }
    //search by Zoho contract id if not found by id
    const contractByZohoId = Object.values(existingContracts).find(contract => contract.zohoContractId === hashId)
    if (contractByZohoId) {
      pushToOpenedContracts(contractByZohoId)
      return
    }
    alert('Contract not found for id: ' + hashId)
  }, [hash, existingContracts])

  // Contract status update listener for all contracts of given Zoho contact ID
  useEffect(() => {
    if (!id) return

    window.Echo.channel(`contract.status.${id}`).listen('.operation.success', e => {
      if (e.data && e.data.contractId) {
        dispatch(
          updateContractDefaultData({
            id: e.data.contractId,
            data: { status: e.data.status, transfertLog: e.data.transfertLog || null },
          }),
        )
        dispatch(updateContractConfigData({ id: e.data.contractId, data: { isEditable: e.data.isEditable } }))
      }
    })

    return () => {
      window.Echo.leaveChannel(`contract.status.${id}`)
    }
  }, [id])

  // Load VA data
  useEffect(() => {
    if (!contactId) return
    dispatch({ type: subscriptionFormActionsV2.LOAD_ADDITIONAL_SALES_CONFIG })
    dispatch({ type: subscriptionFormActionsV2.LOAD_EXISTING_ADDITIONAL_SALES, contactId })
  }, [contactId])
}

export default useSubscriptionForm
